export const paths = {
  ggr: '/proekty',
};
